import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class DatePickerField extends Component {
    render() {
        return (
            <DatePicker
                className="form-control"
                onChange={(date) => this.props.input.onChange(date)}
                dateFormat="DD-MM-YYYY"
                selected={(this.props.input.value) ? moment(this.props.input.value) : null}
                placeholderText={this.props.placeholder}
            />
        );
    }
}

export default DatePickerField